import React from "react";
import Modal from "components/modal";
import Content from "./tabs";
import useToggle from "hooks/useToggle";
import { ReactComponent as OpenModal } from "assets/svgs/open-modal.svg";
import { useGlobalContext } from "context/global";

const BundleDetails = ({ data }) => {
	const { translation } = useGlobalContext();
	const productCount = data?.product?.details?.products?.length;
	const [isOpen, toggle] = useToggle();

	return (
		<>
			{isOpen && (
				<Modal hideHeader={true} isOpen={isOpen} close={toggle} className="md:w-1/2">
					<Content data={data} closeModal={toggle} />
				</Modal>
			)}
			<button
				className="text-black border-gray-300 border-[1px] rounded-3xl w-full md:w-3/4 py-2 px-4 flex justify-between"
				onClick={toggle}
			>
				<span>
					{productCount} {translation?.product?.clickForDetails}
				</span>
				<OpenModal />
			</button>
		</>
	);
};

export default BundleDetails;
